module.exports = __webpack_public_path__ + "img/view-line-cards.8b669268.png";